import { cn } from '@/lib/utils';

type CardTitleProps = React.ComponentProps<'div'>;

export const CardTitle = ({ className, ...props }: CardTitleProps) => (
  <div
    data-slot="card-title"
    className={cn(
      'tw-text-base tw-leading-snug tw-font-medium group-data-[size=sm]/card:tw-text-sm',
      className,
    )}
    {...props}
  />
);
